import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService, WorkoutService } from '../services';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WorkoutGuard implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService,
        private workoutService: WorkoutService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        if (this.authService.getUserToken()) {
            return this.workoutService.canAccess(route.paramMap.get('id')).pipe(map(res => {
                if (res.canAccess) {
                    return true;
                } else {
                    this.router.navigate(['/workout']);
                    return false;
                }
            }));
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/workout']);
        return of(false);
    }
}
